<template>
  <!-- toast -->
  <AlertMsg :msg="msgObj.msg" :show="msgObj.show" :role="msgObj.role" @closePopup="msgObj.show = false"></AlertMsg>
  <!-- end toast -->
  <div class="row">
    <div class="col-12">
      <div class="d-flex align-items-center mt-2">
        <h5 class="mb-0 text-primary"><i class="fa fa-magic text-primary"></i> Festival</h5>
      </div>
      <hr />
      <div class="row g-3">
        <div class="col-md-3">
          <label class="form-label">Festival Name<sup><span class="text-danger font-12">*</span></sup>
            :</label>
          <input type="text" class="form-control form-control-sm" v-model="Obj.FestivalName" />
        </div>
        <div class="col-md-3">
          <label class="form-label">Date<sup><span class="text-danger font-12">*</span></sup> :</label>
          <input type="date" class="form-control form-control-sm" v-model="Obj.FestivalDate" />
        </div>
        <div class="col-md-3">
          <label class="form-label">Image :</label>
          <label for="fileInput" class="attachment-icon" >
              <i class="fa fa-upload"></i>
            </label>
          <input class="form-control" id="fileInput" type="file" multiple accept=".png,.jpg,.jpeg,.webp,.pdf,.docx,.doc,.xls,.txt" @change="UploadImg" /><br/>
           <small class="form-text text-danger">Upload 800x800 size files only</small>
           <div class="d-flex align-items-start">
          <a  v-if="Obj.Image" :href="getUrl(Obj.Image)" target="_blank"  class="clearfix">{{Obj.Image.substring(Obj.Image.lastIndexOf('/') + 1)  }} </a>
          <i role="button" v-if="Obj.Image !== ''" @click="deleteFile(Obj.Image)" class="fa-solid fa-x text-danger f-5 mt-2 ms-1"></i>
        </div></div>
        <div class="col-md-9 text-end mt-2">
          <button class="btn btn-sm btn-darknavy me-1" @click="save()">
            <i class="fa fa-save"></i> Save
          </button>
           <button type="button" class="btn btn-sm btn-soft-dark" @click="reset()"><i class="fa fa-times-circle  me-1"></i> Cancel</button>
        </div>
      </div>
        <ul v-if="errors.length" class="text-danger ps-3">
          <li v-for="(err, index) in errors" :key="index">{{ err }}</li>
        </ul>
      <div class="row">
        <div class="col-md-9 table-responsive mt-2">
          <div class="progress mb-0 progress-sm" v-if="progress!=0">
        <div class="progress-bar" role="progressbar" :aria-valuenow="progress" aria-valuemin="0" aria-valuemax="100"
          :style="{ width: progress + '%' }"></div>
      </div>
          <DataTable  v-if="progress==0" :columns="cols" :rows="rows" :pageSize="10"   :actions="{  edit: handleEdit, delete: handleDelete }" />
        </div>
      </div>
    </div>
  </div>
  <DelPopup :name="delObj.FestivalName" @delRecord="delRecord" @closeModal="delObj.FestivalName = ''"></DelPopup>
</template>
<script setup>
import AlertMsg from "@/components/Common/AlertMsg.vue";
import DelPopup from "@/components/Common/DelPopup.vue";
import DataTable from "@/components/Common/DataTable.vue";
import { isRequired, validateForm } from "@/utils/validation.js";
import { useFileUpload } from "@/utils/fileUpload";
const { handleFileUploadImg } = useFileUpload();
import { formatDate, curdStatus, api } from '@/utils/helpers.js';
import { ref, onMounted} from 'vue'
  const  Obj = ref({ FestivalName: "", FestivalDate: new Date().toISOString().slice(0, 10), Image: "", })
    const   msgObj= ref({ msg: "", role: "", show: false, })
    const   delObj = ref({})
    const   errors= ref({})
const cols=ref([
  { label: 'S.No', key: 'Sno' },
  { label: 'Festival Name', key: 'FestivalName' },
  { label: 'Date', key: 'Date' },
  { label: 'Image', key: 'Image', type:'image'}
]);
const handleEdit = (row) => {
    Obj.value = { ...row,
       FestivalDate: row.FestivalDate ? row.FestivalDate.slice(0, 10) : new Date().toISOString().slice(0, 10),
      }
     if (Obj.value.Image?.startsWith(process.env.VUE_APP_API_URL)) {
    Obj.value.Image = Obj.value.Image.replace(process.env.VUE_APP_API_URL, '');
  }
}
const handleDelete = (row) => {
  delObj.value = { ...row };
}
const UploadImg = async (event) => {
  const file = event.target.files[0];
  if (!file) return;
const { file: uploadedFile, message } = await handleFileUploadImg(file);
  if (message) {
    msgObj.value = { msg: message, role: "danger", show: true };
    event.target.value = ""; 
    return;
  }
  if (uploadedFile) { Obj.value.Image = uploadedFile; }
event.target.value = null;
};
const rows=ref([])
 const  save =async() => {
      const fields = {
        FestivalName: { value: Obj.value.FestivalName, validators: [isRequired], },
        Date: { value: Obj.value.FestivalDate, validators: [isRequired], },
      };
      errors.value = validateForm(fields);
      if (Object.keys(errors.value).length === 0) {
        const { url, method, msg } = curdStatus(Obj.value);
        await api[method](`/Festival${url}`, Obj.value)
          .then(() => {
            loadData();
            reset();
            msgObj.value = { msg: `Festival ${msg} Successfuly`, role: "success", show: true, };
          })
          .catch((error) => { console.log(error); });
      }
    }
    const reset =async () =>{
      Obj.value = { FestivalName: "", FestivalDate:  new Date().toISOString().slice(0, 10), Image: "", };
      msgObj.value = { msg: "", role: "", show: false, };
      errors.value={};
    }
      const progress = ref(0)
    const loadData =async () => {
          let direction = 1
     let progressInterval = setInterval(() => {
       progress.value += direction
       if (progress.value >= 100) {
         progress.value = 0 
       }
     }, 100)
      await api.get('/Festival/all')
        .then((response) => {
         rows.value = response.data.map((item, i) => ({ ...item, Sno: i + 1, 
        Date: formatDate(item.FestivalDate),Image:item.Image, }));
          progress.value = 0
          clearInterval(progressInterval)
        });
    }
    const deleteFile = async (filePath) => {
      if (!filePath) return;
      const fileName = filePath.split('/').pop();

      try {
        await api.delete(`/documents/students?filename=${fileName}`);
        Obj.value.Image = '';
      } catch (err) {
        msgObj.value = { msg: 'Failed to delete image.', role: 'danger', show: true };
      }
    };
    const delRecord =async () => {
      await api.delete(`/Festival/${delObj.value._id}`)
        .then(() => {
          loadData();
          delObj.value={};
          msgObj.value = { msg: "Festival Deleted Successfuly.", role: "danger", show: true, };
        });
    }
    const getUrl= (img)=> {
      let imgUrl = img.startsWith("..")
          ? img.substring(2)
          : img;
      
  const base = process.env.VUE_APP_API_URL.replace(/\/+$/, "");
  const path = imgUrl.replace(/^\/+/, "");
  return `${base}/${path}`;
    }
      onMounted(() => { loadData() })
</script>